var Pandora = Pandora || {};

Pandora.ApplicableBenefitHandler = {
  init: function() {
    this._$brokerSelect = $('#broker_select');
    this._$typeSelect = $('#benefitiable_type_select');
    this._$benefitiableSelect = $('#benefitiable_id_select');
    this._$form = $('form.formtastic');
    this._$modal = $('#organization_change_modal');
    this._pendingSubmit = false;

    if (!this._$typeSelect.length || !this._$benefitiableSelect.length) return;

    this._$typeSelect.on('change', $.proxy(this._onTypeChange, this));
    this._$brokerSelect.on('change', $.proxy(this._onBrokerChange, this));
    this._$form.on('submit', $.proxy(this._onFormSubmit, this));

    $('#modal_cancel').on('click', $.proxy(this._hideModal, this));
    $('#modal_confirm').on('click', $.proxy(this._confirmChange, this));

    this._onTypeChange();
  },

  _onTypeChange: function() {
    var selectedType = this._$typeSelect.val();

    this._$benefitiableSelect.empty();

    if (selectedType === 'Broker::OrganizationAffiliation') {
      this._loadOrganizationAffiliations();
    } else if (selectedType === 'Broker::RegisteredCampaign') {
      this._loadRegisteredCampaigns();
    } else if (selectedType === 'Broker::Benefit') {
      this._loadBenefits();
    }
  },

  _onBrokerChange: function() {
    var selectedType = this._$typeSelect.val();

    if (selectedType === 'Broker::Benefit') {
      this._loadBenefits();
    }
  },

  _loadOrganizationAffiliations: function() {
    this._$benefitiableSelect.prop('disabled', true);
    this._$benefitiableSelect.append('<option value="">Loading...</option>');

    $.ajax({
      url: '/admin/broker_applicable_benefits/organization_affiliations',
      dataType: 'json',
      context: this,
      success: function(data) {
        this._$benefitiableSelect.empty();
        this._$benefitiableSelect.append('<option value=""></option>');

        $.each(data, $.proxy(function(_, item) {
          this._$benefitiableSelect.append($('<option>', { value: item.id, text: item.name }));
        }, this));

        this._$benefitiableSelect.prop('disabled', false);
      },
      error: function() {
        this._$benefitiableSelect.empty();
        this._$benefitiableSelect.append('<option value="">Error loading data</option>');
        this._$benefitiableSelect.prop('disabled', true);
      }
    });
  },

  _loadRegisteredCampaigns: function() {
    this._$benefitiableSelect.prop('disabled', true);
    this._$benefitiableSelect.append('<option value="">Loading...</option>');

    $.ajax({
      url: '/admin/broker_applicable_benefits/registered_campaigns',
      dataType: 'json',
      context: this,
      success: function(data) {
        this._$benefitiableSelect.empty();
        this._$benefitiableSelect.append('<option value=""></option>');

        $.each(data, $.proxy(function(_, item) {
          this._$benefitiableSelect.append($('<option>', { value: item.id, text: item.name }));
        }, this));

        this._$benefitiableSelect.prop('disabled', false);
      },
      error: function() {
        this._$benefitiableSelect.empty();
        this._$benefitiableSelect.append('<option value="">Error loading data</option>');
        this._$benefitiableSelect.prop('disabled', true);
      }
    });
  },

  _loadBenefits: function() {
    var brokerId = this._$brokerSelect.val();

    if (!brokerId) {
      this._$benefitiableSelect.empty();
      this._$benefitiableSelect.append('<option value="">Select a broker first</option>');
      return;
    }

    this._$benefitiableSelect.prop('disabled', true);
    this._$benefitiableSelect.empty();
    this._$benefitiableSelect.append('<option value="">Loading...</option>');

    $.ajax({
      url: '/admin/brokers/' + brokerId + '/available_benefits',
      dataType: 'json',
      context: this,
      success: function(data) {
        this._$benefitiableSelect.empty();
        this._$benefitiableSelect.append('<option value=""></option>');

        $.each(data, $.proxy(function(_, item) {
          this._$benefitiableSelect.append($('<option>', { value: item.id, text: item.name }));
        }, this));

        this._$benefitiableSelect.prop('disabled', false);
      },
      error: function() {
        this._$benefitiableSelect.empty();
        this._$benefitiableSelect.append('<option value="">Error loading benefits</option>');
        this._$benefitiableSelect.prop('disabled', true);
      }
    });
  },

  _onFormSubmit: function(event) {
    var selectedType = this._$typeSelect.val();
    var brokerId = this._$brokerSelect.val();

    if (selectedType !== 'Broker::OrganizationAffiliation' || this._pendingSubmit) {
      return true;
    }

    event.preventDefault();

    $.ajax({
      url: '/admin/broker_applicable_benefits/check_existing_affiliation',
      data: { broker_id: brokerId },
      dataType: 'json',
      context: this,
      success: function(data) {
        if (data.has_affiliation) {
          this._showModal(data.organization_names);
        } else {
          this._pendingSubmit = true;
          this._$form.submit();
        }
      }
    });
  },

  _showModal: function(organizationNames) {
    var message = 'El broker ya tiene asignada la organización: <strong>' + organizationNames + '</strong>. ¿Desea cambiarla?';
    $('#modal_message').html(message);
    this._$modal.show();
  },

  _hideModal: function() {
    this._$modal.hide();
    this._pendingSubmit = false;
  },

  _confirmChange: function() {
    this._hideModal();
    this._pendingSubmit = true;
    this._$form.submit();
  }
};
